import React, { useEffect, useState, useContext } from 'react';
// @ts-ignore
import '../../assets/css/Viewer.css';
import { saveImageResponse } from '../../types/Search';
import { Form, FormLabel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import ImageModal from '../layout/ImageModal';
import HelpModal from '../layout/HelpModal';
import { userActivity, pan, invert, rotate, IOperation } from '../../types/userActivity';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useOktaAuth } from '@okta/okta-react';
import useViewerUtil from './useViewerUtil';

import {
    faSave,
    faPrint,
    faSearchPlus,
    faSearchMinus,
    faStepBackward,
    faStepForward,
    faRedo,
    faUndo,
    faExpand,
    faCamera,
    faStar,
    faPencil,
    faImages,
} from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarOutline } from '@fortawesome/free-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ImageDataContext from '../../providers/imageData-context';
import LoadingContext from '../layout/search/loading-context';
import Common from '../../common/Common';
import { PrintImageResponse } from '../../types/PrintImageResponse';
import IFramePrinter from '../utility/IFramePrinter';
import ImageService from '../../services/ImageService';
import { responseContainer } from '../../types/response/ResponseContainer';

const THUMBNAIL_PAGE_SIZE = 25;

export interface Props {
    isSearchBarOpen: boolean;
}

export const Viewer: React.FC<Props> = ({ ...Props }) => {
    const {
        containerRef,
        wrapperRef,
        imgRef,
        mouseDown,
        mouseWheel,
        mouseLeave,
        rotateCW,
        rotateACW,
        toggleGrayscale,
        zoomIn,
        reset,
        zoomOut,
        imageLoad,
        resetImage,
        resetForNextPrevious,
        ...state
    } = useViewerUtil(updateParentState);

    const imageDataCtx = useContext(ImageDataContext);
    const loadingCtx = useContext(LoadingContext);

    const [positionState, setPositionState] = useState({
        x: 0,
        y: 0,
        z: 1,
        oldX: 0,
        oldY: 0,
    });
    const [rotationDegState, setRotationDegState] = useState(0);
    const [grayScaleState, setGrayScaleState] = useState(0);

    const [show, setShow] = useState(false);
    const [helpShow, setHelpShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const helpHandleClose = () => setHelpShow(false);
    const helpHandleShow = () => setHelpShow(true);

    // Navigation states
    const [imgName, setImgName] = React.useState('');
    const [imgkey, setImgKey] = React.useState('');

    const [isError, setIsError] = useState(false);

    const [error, setError] = useState<AxiosError>();
    const { oktaAuth, authState } = useOktaAuth();

    const [goToPage, setGoToPage] = React.useState('');

    const [disableSave, setDisableSave] = useState(false);
    const [urlToPrint, setUrlToPrint] = useState<string>('');

    const [brightness, setBrightness] = useState<number>(100);
    const [contrast, setContrast] = useState<number>(100);
    const [mirrored, setMirrored] = useState<boolean>(false);
    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
    const [isPrintOpen, setIsPrintOpen] = useState<boolean>(false);
    const [isSaveOpen, setIsSaveOpen] = useState<boolean>(false);
    const [pagesToExport, setPagesToExport] = useState('');
    const [exportError, setExportError] = useState('');

    const [isThumbnailView, setIsThumbnailView] = useState<boolean>(false);
    const [hasOpenedThumbnailView, setHasOpenedThumbnailView] = useState<boolean>(false);
    const [thumbnailPage, setThumbnailPage] = useState<number>(1);
    const [thumbnailGoToPage, setThumbnailGoToPage] = useState<string>('');

    var uid: string = '';
    var userName: string = '';
    var accessToken: string = '';
    let maximumTaggedPages: number = 10;
    const INTERNAL_GROUP_NAME = 'Okta - Org2Org Federated Users';

    if (authState.isAuthenticated) {
        uid = authState.accessToken.claims?.uid;
        userName = authState.accessToken.claims?.sub;
        accessToken = authState.accessToken.accessToken;

        if (
            authState.accessToken.claims !== undefined &&
            authState.accessToken.claims.Groups !== undefined &&
            authState.accessToken.claims.Groups.length > 0
        ) {
            var filteredStrings = authState.accessToken.claims.Groups.map((str: string) =>
                str.toLowerCase()
            );
            if (filteredStrings.includes(INTERNAL_GROUP_NAME.toLowerCase())) {
                maximumTaggedPages = 25;
            }
        }
    } else {
        // How to get this in the error Boundary???
        throw new Error('User Unauthorized');
    }

    function updateParentState(transform: any = null, invert: any = null, rotate: any = null) {
        var temp;
        if (transform != null) {
            temp = transform;
            setPositionState(temp);
        }

        if (rotate != null) {
            temp = rotate;
            setRotationDegState(state.rotationDegree);
        }

        if (invert != null) {
            temp = invert;
            setGrayScaleState(state.invert);
        }
    }

    useEffect(() => {
        if (
            !imageDataCtx.loadedImageDetails ||
            !imageDataCtx.loadedImagePageNumber ||
            !imageDataCtx.loadedImagePageUrl
        ) {
            return;
        }

        setGoToPage('');
        setExportError('');

        var key = imageDataCtx.loadedImageDetails.name + '_' + imageDataCtx.loadedImagePageNumber;
        resetForNextPrevious();

        if (key !== '' && imgkey !== key) {
            setImgKey(key);
            collect(key);
        }

        var activityJson = window.sessionStorage.getItem(key);

        let loadActivity = null;
        if (activityJson) {
            loadActivity = JSON.parse(activityJson) as userActivity;
            var pan = loadActivity.operations.find((x) => x.operationType == 'pan') as pan;
            var rotate = loadActivity.operations.find((x) => x.operationType == 'rotate') as rotate;
            var invert = loadActivity.operations.find((x) => x.operationType == 'invert') as invert;

            setPositionState({
                oldX: pan.oldX,
                oldY: pan.oldY,
                x: pan.posX,
                y: pan.posY,
                z: pan.posZ,
            });
            setRotationDegState(rotate.rotationDegrees);
            setGrayScaleState(invert.grayscale);
        }

        return () => {};
    }, [
        imageDataCtx.loadedImageDetails,
        imageDataCtx.loadedImagePageNumber,
        imageDataCtx.loadedImagePageUrl,
        imageDataCtx.taggedPages,
    ]);

    useEffect(() => {
        setBrightness(100);
        setContrast(100);
        setIsEditOpen(false);
        setIsPrintOpen(false);
        setIsSaveOpen(false);
        setIsThumbnailView(false);
        setHasOpenedThumbnailView(false);
        setThumbnailPage(1);
        setThumbnailGoToPage('');
        setPagesToExport('');

        return () => {};
    }, [imageDataCtx.loadedImageDetails]);

    const onGoToPageSubmit = (e: any) => {
        e.preventDefault();
        if (goToPage) {
            const goToPageAsNumber: number = Number(goToPage);
            imageDataCtx.setLoadedImagePageNumber(goToPageAsNumber);
            setMirrored(false);
            setGoToPage('');
        }
    };

    const onKeyPressGoToPage = (e: any) => {
        if (goToPage === '') {
            return;
        }

        if (e.nativeEvent.code == 'Tab') {
            onGoToPageSubmit(e);
        }
    };

    const onChangeGoToPage = (e: any) => {
        if (e.target.value === '') {
            setGoToPage('');
            return;
        }

        let tmpInput = e.target.value;
        if (tmpInput.includes('.')) {
            const arr1: string[] = tmpInput.split('.');
            tmpInput = arr1[0];
        }

        let tmpGoToPage: number = Number(tmpInput);

        if (Number.isNaN(tmpGoToPage)) {
            setGoToPage('');
            return;
        }

        if (tmpGoToPage === 0) {
            setGoToPage('');
            return;
        }

        if (tmpGoToPage < 1) {
            tmpGoToPage = 1;
        } else if (tmpGoToPage === 0) {
            setGoToPage('');
        } else if (tmpGoToPage >= imageDataCtx.loadedImageDetails.pageCount) {
            tmpGoToPage = imageDataCtx.loadedImageDetails.pageCount;
        }
        setGoToPage(tmpGoToPage.toString());
    };

    const getTaggedPagesAsString = (includeSpace: boolean) => {
        let pageList = '';
        let taggedPagesAsArray: Array<number> = Array.from(imageDataCtx.taggedPages) as number[];
        let previousPage: number = 0;
        let currentPage: number = 0;
        let lastPageAddedToString: number = 0;
        taggedPagesAsArray
            .sort((a, b) => a - b)
            .forEach((el) => {
                if (typeof el === 'number') {
                    currentPage = el;
                }
                if (previousPage === 0) {
                    pageList += currentPage.toString();
                    previousPage = currentPage;
                    lastPageAddedToString = currentPage;
                    return;
                }
                let nextAdjacentPage = previousPage + 1;
                if (nextAdjacentPage === currentPage) {
                    // if the currentPage is +1 from the previous page, we track that as the previous page and will print with - once a space has been found.
                    previousPage = currentPage;
                } else {
                    // This means the currentPage needs to get printed.
                    // But before doing so we need to check if the previous page was already printed.
                    if (previousPage !== lastPageAddedToString) {
                        pageList += '-' + previousPage;
                    }
                    pageList += ',';
                    if (includeSpace) {
                        pageList += ' ';
                    }
                    pageList += currentPage;
                    previousPage = currentPage;
                    lastPageAddedToString = currentPage;
                }
            });
        if (currentPage !== lastPageAddedToString) {
            pageList += '-' + currentPage;
        }

        return pageList;
    };

    const isCurrentlyTagged = imageDataCtx.taggedPages.has(imageDataCtx.loadedImagePageNumber);
    let taggedTooltip = '';
    let maximumPagesTagged = false;
    if (imageDataCtx.taggedPages.size == 0) {
        taggedTooltip = 'No pages currently tagged.';
    } else {
        let pageList = getTaggedPagesAsString(true);

        taggedTooltip = `Current tagged pages: ${pageList}.`;
        if (imageDataCtx.taggedPages.size == maximumTaggedPages) {
            maximumPagesTagged = true;
            taggedTooltip += ' Maximum pages have been tagged.';
        }
    }
    const isTaggingDisabled = !isCurrentlyTagged && maximumPagesTagged;

    const toggleTag = () => {
        if (isCurrentlyTagged) {
            imageDataCtx.removeTaggedPage(imageDataCtx.loadedImagePageNumber);
        } else {
            imageDataCtx.addTaggedPage(imageDataCtx.loadedImagePageNumber);
        }
    };

    const executeSave = (pagesToInclude: number[]) => {
        collect();
        setDisableSave(true);
        loadingCtx.setIsLoading(true, 'Viewer Save');

        var item = window.sessionStorage.getItem(imgkey);
        if (item) {
            const activity = JSON.parse(item);
            const saveFilename = Common.generateFileNameExport(imageDataCtx.loadedImageDetails);
            ImageService.saveImageRequest(activity, accessToken, saveFilename, pagesToInclude)
                .then((res) => {
                    const castedResponse: responseContainer = res as responseContainer;
                    const jobResponse: PrintImageResponse =
                        castedResponse?.output as PrintImageResponse;
                    const fileToDownload = {
                        document: imageDataCtx.loadedImageDetails,
                        imageURL: jobResponse.imageURL,
                        fileName: saveFilename,
                    } as saveImageResponse;
                    downloadFile(fileToDownload, 1);
                })
                .catch((ex) => {
                    //setError(ex);
                    //setIsError(true);
                    alert(`Image failed to save:\r\n${saveFilename}\r\n\r\nPlease try again.`);
                    imageDataCtx.clearTaggedPages();
                    loadingCtx.setIsLoading(false, 'Viewer Save');
                    setDisableSave(false);
                });
        }
    };

    function downloadFile(saveImageResponses: saveImageResponse, totalCount: number) {
        if (saveImageResponses && saveImageResponses.imageURL) {
            const sasUrl = saveImageResponses?.imageURL;
            const link = document.createElement('a');
            document.body.appendChild(link);
            link.href = sasUrl;
            link.click();
            document.body.removeChild(link);
        } else {
            alert(
                `Image failed to save:\r\n${saveImageResponses.fileName}\r\n\r\nPlease try again.`
            );
        }
        imageDataCtx.clearTaggedPages();
        loadingCtx.setIsLoading(false, 'Viewer Save');
        setDisableSave(false);
    }

    const executePrint = (pagesToInclude: number[]) => {
        collect();
        loadingCtx.setIsLoading(true, 'Viewer Print');

        var item = window.sessionStorage.getItem(imgkey);
        if (item) {
            const activity = JSON.parse(item);
            const printFilename = imageDataCtx.loadedImageDetails.documentName + '_merged';
            ImageService.printImageRequest(activity, accessToken, printFilename, pagesToInclude)
                .then((response) => {
                    if (response.status == 200) {
                        const printImageResponse = response.output as PrintImageResponse;
                        const sassUrl = printImageResponse.imageURL;
                        setUrlToPrint(sassUrl);
                        imageDataCtx.clearTaggedPages();
                        loadingCtx.setIsLoading(false, 'Viewer Print');
                    }
                })
                .catch((ex) => {
                    //setError(ex);
                    //setIsError(true);
                    imageDataCtx.clearTaggedPages();
                    loadingCtx.setIsLoading(false, 'Viewer Print');
                });
        }
    };

    function collect(key: string = '') {
        var panState: pan = {
            operationType: 'pan',
            posX: state.x,
            posY: state.y,
            posZ: state.z,
            oldX: state.oldX,
            oldY: state.oldY,
        };
        var invertState: invert = {
            operationType: 'invert',
            grayscale: state.invert,
        };
        var rotationState: rotate = {
            operationType: 'rotate',
            rotationDegrees: state.rotationDegree,
        };
        var operations: IOperation[] = [];

        operations.push(panState);
        operations.push(invertState);
        operations.push(rotationState);

        var activity: userActivity = {
            uId: uid,
            userName: userName,
            operations: operations,
            imageUrl: imageDataCtx.loadedImagePageUrl,
            imageName: imageDataCtx.loadedImageDetails.name,
            pageIndex: imageDataCtx.loadedImagePageNumber,
            state: imageDataCtx.loadedImageDetails.state,
            county: imageDataCtx.loadedImageDetails.county,
        };
        window.sessionStorage.setItem(imgkey === '' ? key : imgkey, JSON.stringify(activity));
    }

    function AdjustScroll(position: string) {
        switch (position) {
            case 'initial':
                containerRef.current.scroll(0, 0);
                break;
            case 'center':
                containerRef.current.scroll(
                    (containerRef.current.scrollWidth - containerRef.current.clientWidth) / 2,
                    (containerRef.current.scrollHeight / 2 -
                        containerRef.current.clientHeight / 2) /
                        4
                );
                break;
            case 'hcenter':
                containerRef.current.scroll(
                    0,
                    (containerRef.current.scrollHeight - containerRef.current.clientHeight) / 2
                );
        }
    }

    function performRotate(diretion: string) {
        switch (diretion) {
            case 'ACW':
                rotateACW(
                    state.rotationDegree,
                    imgRef.current.scrollWidth,
                    imgRef.current.scrollHeight,
                    containerRef.current.clientWidth,
                    containerRef.current.clientHeight
                );
                //state.rotationDegree == -90 && AdjustScroll('hcenter');
                break;
            case 'CW':
                rotateCW(
                    state.rotationDegree,
                    containerRef.current.scrollWidth,
                    containerRef.current.scrollHeight,
                    containerRef.current.clientWidth,
                    containerRef.current.clientHeight
                );
            //state.rotationDegree == 90 && AdjustScroll('hcenter');
        }
    }

    const moveFirstPageEnabled = imageDataCtx.loadedImagePageNumber != 1;
    const moveLastPageEnabled =
        imageDataCtx.loadedImagePageNumber != imageDataCtx.loadedImageDetails.pageCount;

    const currentList = imageDataCtx.loadedImageFromImageList
        ? imageDataCtx.imagesList
        : imageDataCtx.activityHistory;
    const currentIndex = currentList.findIndex(
        (x) => x.name === imageDataCtx.loadedImageDetails.name
    );

    const previousDocumentEnabled = currentIndex > 0;
    const nextDocumentEnabled = currentIndex + 1 !== currentList.length;
    const previousPageEnabled = imageDataCtx.loadedImagePageNumber > 1 || previousDocumentEnabled;
    const nextPageEnabled =
        imageDataCtx.loadedImagePageNumber < imageDataCtx.loadedImageDetails.pageCount ||
        (imageDataCtx.loadedImagePageNumber === imageDataCtx.loadedImageDetails.pageCount &&
            nextDocumentEnabled);

    const onMoveFirstPage = () => {
        setMirrored(false);
        imageDataCtx.setLoadedImagePageNumber(1);
    };

    const onMoveLastPage = () => {
        setMirrored(false);
        imageDataCtx.setLoadedImagePageNumber(imageDataCtx.loadedImageDetails.pageCount);
    };

    const onPreviousPage = () => {
        setMirrored(false);
        if (imageDataCtx.loadedImagePageNumber == 1) {
            // If the current page is 1, then we move to the previous document in the list.
            onPreviousDocument();
        } else {
            imageDataCtx.setLoadedImagePageNumber(imageDataCtx.loadedImagePageNumber - 1);
        }
    };

    const onNextPage = () => {
        setMirrored(false);
        if (imageDataCtx.loadedImagePageNumber == imageDataCtx.loadedImageDetails.pageCount) {
            onNextDocument();
        } else {
            imageDataCtx.setLoadedImagePageNumber(imageDataCtx.loadedImagePageNumber + 1);
        }
    };

    const onPreviousDocument = () => {
        setMirrored(false);
        const currentList = imageDataCtx.loadedImageFromImageList
            ? imageDataCtx.imagesList
            : imageDataCtx.activityHistory;
        const currentIndex = currentList.findIndex(
            (x) => x.name === imageDataCtx.loadedImageDetails.name
        );

        let newIndex = currentIndex - 1;
        if (currentIndex === -1) {
            // This means we didn't find the selected documentName in the imagesList.
            // This shouldn't be possible because if we remove an image from the imagesList
            // and it is currently loaded, we clear the loaded image.
            // As a failsafe, I will just set the newIndex to 0 (loading the top image)
            newIndex = 1;
        }
        if (currentIndex === 0) {
            // This also shouldn't be possible, because the previous document button
            // will be disabled when on the first item.  But we will again set to 1 as a failsafe.
            newIndex = 1;
        }

        imageDataCtx.setLoadedImage(
            imageDataCtx.loadedImageFromImageList
                ? imageDataCtx.imagesList[newIndex].name
                : imageDataCtx.activityHistory[newIndex].name,
            imageDataCtx.loadedImageFromImageList
        );
    };

    const onNextDocument = () => {
        setMirrored(false);
        const currentList = imageDataCtx.loadedImageFromImageList
            ? imageDataCtx.imagesList
            : imageDataCtx.activityHistory;
        const currentIndex = currentList.findIndex(
            (x) => x.name === imageDataCtx.loadedImageDetails.name
        );

        let newIndex = currentIndex + 1;
        if (currentIndex === -1) {
            // This means we didn't find the selected documentName in the imagesList.
            // This shouldn't be possible because if we remove an image from the imagesList
            // and it is currently loaded, we clear the loaded image.
            // As a failsafe, I will just set the newIndex to 0 (loading the top image)
            newIndex = 1;
        }
        if (
            (imageDataCtx.loadedImageFromImageList &&
                newIndex === imageDataCtx.imagesList.length) ||
            (!imageDataCtx.loadedImageFromImageList &&
                newIndex === imageDataCtx.activityHistory.length)
        ) {
            // This also shouldn't be possible, because the next document button
            // will be disabled when on the last item.  But we will again set to 1 as a failsafe.
            newIndex = 1;
        }

        imageDataCtx.setLoadedImage(
            imageDataCtx.loadedImageFromImageList
                ? imageDataCtx.imagesList[newIndex].name
                : imageDataCtx.activityHistory[newIndex].name,
            imageDataCtx.loadedImageFromImageList
        );
    };

    if (!imageDataCtx.loadedImageDetails || !imageDataCtx.loadedImageDetails.name) {
        return (
            <div className='no-data-available-container'>
                <div className='no-data-available'>
                    <h5 className='card-title primary-text'>No Data Available</h5>
                </div>
            </div>
        );
    }

    const onChangeBrightness = (event: React.FormEvent<HTMLInputElement>) => {
        const valueAsNumber: number = +event.currentTarget.value;
        setBrightness(valueAsNumber);
    };

    const onChangeContrast = (event: React.FormEvent<HTMLInputElement>) => {
        const valueAsNumber: number = +event.currentTarget.value;
        setContrast(valueAsNumber);
    };

    const onChangePagesToExport = (event: React.FormEvent<HTMLInputElement>) => {
        const inputValue = event.currentTarget.value;
        const filteredValue = inputValue.replace(/[^-,0-9 ]/gi, '');
        setPagesToExport(filteredValue);
    };

    const onExport = () => {
        setExportError('');
        // Need to turn the pagesToExport string into a number array,
        // removing duplicates and checking for pages that are out of bounds.
        const result: number[] = [];
        let error = '';
        const basePagesToExport = pagesToExport.replace(/[ ]/gi, '');
        const firstSplit = basePagesToExport.split(',');
        firstSplit.forEach((splitValue) => {
            if (splitValue.indexOf('-') > 0) {
                const secondSplit = splitValue.split('-');
                if (secondSplit.length !== 2) {
                    error = 'Invalid page or character';
                    return;
                }
                const tmpValue: number = +secondSplit[0];
                const tmpValue2: number = +secondSplit[1];
                if (tmpValue <= 0 || tmpValue > imageDataCtx.loadedImageDetails.pageCount) {
                    error = 'Invalid page or character';
                    return;
                }
                if (tmpValue2 <= 0 || tmpValue2 > imageDataCtx.loadedImageDetails.pageCount) {
                    error = 'Invalid page or character';
                    return;
                }
                if (tmpValue >= tmpValue2) {
                    error = 'Invalid page or character';
                    return;
                }
                for (let i = tmpValue; i <= tmpValue2; i++) {
                    if (!result.includes(i)) {
                        result.push(i);
                    }
                }
            } else {
                const tmpValue: number = +splitValue;
                if (Number.isNaN(tmpValue)) {
                    error = 'Invalid page or character';
                    return;
                }
                if (tmpValue <= 0 || tmpValue > imageDataCtx.loadedImageDetails.pageCount) {
                    error = 'Invalid page or character';
                    return;
                }
                if (!result.includes(tmpValue)) {
                    result.push(tmpValue);
                }
            }
        });
        if (error.length > 0) {
            setExportError('Error: ' + error);
            return;
        }

        if (result.length > maximumTaggedPages) {
            setExportError(`Error: ${maximumTaggedPages} page limit exeeded`);
            return;
        }

        const sortedResult = result.sort((a, b) => a - b);
        if (isPrintOpen) {
            executePrint(sortedResult);
            setIsPrintOpen(false);
        } else {
            executeSave(sortedResult);
            setIsSaveOpen(false);
        }
        setPagesToExport('');
    };

    const onToggleEditMode = () => {
        if (!isEditOpen) {
            setIsPrintOpen(false);
            setIsSaveOpen(false);
        }
        setIsEditOpen((prevState) => {
            return !prevState;
        });
    };

    const onTogglePrintMode = () => {
        if (!isPrintOpen) {
            setIsEditOpen(false);
            setIsSaveOpen(false);

            if (imageDataCtx.taggedPages.size > 0) {
                setPagesToExport(getTaggedPagesAsString(true));
            } else {
                setPagesToExport('');
            }
        }
        setIsPrintOpen((prevState) => {
            return !prevState;
        });
    };

    const onToggleSaveMode = () => {
        if (!isSaveOpen) {
            setIsEditOpen(false);
            setIsPrintOpen(false);

            if (imageDataCtx.taggedPages.size > 0) {
                setPagesToExport(getTaggedPagesAsString(true));
            } else {
                setPagesToExport('');
            }
        }
        setIsSaveOpen((prevState) => {
            return !prevState;
        });
    };

    const onToggleThumbnailMode = () => {
        if (!isThumbnailView) {
            setIsEditOpen(false);
            setIsPrintOpen(false);
            setIsSaveOpen(false);

            const pageContainingCurrent = Math.ceil(
                imageDataCtx.loadedImagePageNumber / THUMBNAIL_PAGE_SIZE
            );
            setThumbnailPage(pageContainingCurrent);
            setThumbnailGoToPage('');

            if (hasOpenedThumbnailView) {
                setTimeout(() => {
                    const anchoredImage = document.getElementById(
                        'thumbnail-image-' + imageDataCtx.loadedImagePageNumber
                    );
                    if (anchoredImage) {
                        anchoredImage.scrollIntoView({ behavior: 'smooth', inline: 'start' });
                    }
                }, 1000);
            } else {
                setHasOpenedThumbnailView(true);
            }
        }

        setIsThumbnailView((prevState) => {
            return !prevState;
        });
    };

    const exitThumbnailView = (pageNumber: number) => {
        imageDataCtx.setLoadedImagePageNumber(pageNumber);
        setIsThumbnailView(false);
    };

    let pageNumbers = [];
    for (let i = 1; i <= imageDataCtx.loadedImageDetails.pageCount; i++) {
        pageNumbers.push(i);
    }
    const isHierarchy = imageDataCtx.loadedImageDetails.name.startsWith('HIERARCHY_');
    const totalThumbnailPages = Math.ceil(
        imageDataCtx.loadedImageDetails.pageCount / THUMBNAIL_PAGE_SIZE
    );
    const thumbnailStartPage = (thumbnailPage - 1) * THUMBNAIL_PAGE_SIZE + 1;
    const thumbnailEndPage = Math.min(
        thumbnailPage * THUMBNAIL_PAGE_SIZE,
        imageDataCtx.loadedImageDetails.pageCount
    );
    const pagedPageNumbers = pageNumbers.slice(thumbnailStartPage - 1, thumbnailEndPage);

    const onThumbnailFirstPage = () => setThumbnailPage(1);
    const onThumbnailPreviousPage = () => setThumbnailPage((p) => Math.max(1, p - 1));
    const onThumbnailNextPage = () => setThumbnailPage((p) => Math.min(totalThumbnailPages, p + 1));
    const onThumbnailLastPage = () => setThumbnailPage(totalThumbnailPages);
    const onThumbnailGoToPageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value.replace(/[^0-9]/g, '');
        setThumbnailGoToPage(val);
    };
    const onThumbnailGoToPageSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (thumbnailGoToPage) {
            const imageNumber = Math.max(
                1,
                Math.min(imageDataCtx.loadedImageDetails.pageCount, Number(thumbnailGoToPage))
            );
            const pageForImage = Math.ceil(imageNumber / THUMBNAIL_PAGE_SIZE);
            setThumbnailPage(pageForImage);
            setThumbnailGoToPage('');
        }
    };

    const oldPageNumber = imageDataCtx.loadedImagePageNumber;
    const replaceString = isHierarchy
        ? `pageNumber=${oldPageNumber}&isThumbnail=false`
        : '/' + oldPageNumber.toString() + '.';
    const thumbnailViewHtml = (
        <>
            {pagedPageNumbers.map((page, i) => {
                const replacementString = isHierarchy
                    ? `pageNumber=${page}&isThumbnail=true`
                    : '/' + page.toString() + '_thumb.';
                const newUrl = imageDataCtx.loadedImagePageUrl.replace(
                    replaceString,
                    replacementString
                );
                const imageId = 'thumbnail-image-' + page;
                return (
                    <td key={page}>
                        <img
                            className='thumbnail-image'
                            id={imageId}
                            src={newUrl}
                            onClick={() => exitThumbnailView(page)}
                        />
                        <div style={{ textAlign: 'center', width: '100%' }}>
                            <span className='thumbnail-page'>{page}</span>
                        </div>
                    </td>
                );
            })}
        </>
    );

    return (
        <>
            {!isThumbnailView && (
                <section className='viewer-tools w-100 d-flex justify-content-center tools-container'>
                    <div
                        className='toolsSection'
                        onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                    >
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='bottom'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-tag`}>
                                    <strong>Toggle Thumbnail View</strong>
                                </Tooltip>
                            }
                        >
                            <a id='tooltip-tag' className='tools' onClick={onToggleThumbnailMode}>
                                <div className='tools-button-div'>
                                    <FontAwesomeIcon icon={faImages} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='bottom'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-tag`}>
                                    <strong>Adjust Brightness and Contrast</strong>
                                </Tooltip>
                            }
                        >
                            <a id='tooltip-tag' className='tools' onClick={onToggleEditMode}>
                                <div
                                    className={
                                        isEditOpen
                                            ? 'tools-button-div selected'
                                            : 'tools-button-div'
                                    }
                                >
                                    <FontAwesomeIcon icon={faPencil} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='bottom'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-tag`}>
                                    <>
                                        <strong>Tag page for printing/saving.</strong>
                                        <br />
                                        <span>{taggedTooltip}</span>
                                    </>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-tag'
                                className={isTaggingDisabled ? 'disableLinkTag' : 'tools'}
                                onClick={
                                    isTaggingDisabled
                                        ? () => {
                                              return false;
                                          }
                                        : toggleTag
                                }
                            >
                                <div
                                    className={
                                        isTaggingDisabled
                                            ? 'tools-button-div-disabled'
                                            : 'tools-button-div'
                                    }
                                >
                                    <FontAwesomeIcon
                                        icon={isCurrentlyTagged ? faStar : faStarOutline}
                                        size='1x'
                                    />
                                </div>
                            </a>
                        </OverlayTrigger>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-imagesave`}>
                                    <strong>Save Tagged Pages</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-imagesave'
                                className={disableSave ? 'disableViewerButton' : 'tools'}
                                onClick={(e) => onToggleSaveMode()}
                            >
                                <div
                                    className={
                                        isSaveOpen
                                            ? 'tools-button-div selected'
                                            : 'tools-button-div'
                                    }
                                >
                                    <FontAwesomeIcon icon={faSave} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement={'top'}
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-printimage`}>
                                    <strong>Print Tagged Pages</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-printimage'
                                onClick={(e) => onTogglePrintMode()}
                                className={'tools'}
                            >
                                <div
                                    className={
                                        isPrintOpen
                                            ? 'tools-button-div selected'
                                            : 'tools-button-div'
                                    }
                                >
                                    <FontAwesomeIcon icon={faPrint} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-zoomin`}>
                                    <strong>Zoom In</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-zoomin'
                                className='tools'
                                onClick={() => {
                                    zoomIn(
                                        containerRef.current.scrollWidth,
                                        containerRef.current.clientWidth,
                                        containerRef.current.clientHeight
                                    );
                                }}
                            >
                                <div className='tools-button-div'>
                                    <FontAwesomeIcon icon={faSearchPlus} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-zoomout`}>
                                    <strong>Zoom Out</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-zoomout'
                                className='tools'
                                onClick={() => {
                                    zoomOut(
                                        containerRef.current.scrollWidth,
                                        containerRef.current.clientWidth,
                                        containerRef.current.clientHeight
                                    );
                                }}
                            >
                                <div className='tools-button-div'>
                                    <FontAwesomeIcon icon={faSearchMinus} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip--reset-image`}>
                                    <strong>Reset Image</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-reset-image'
                                className='tools'
                                onClick={() => {
                                    resetImage(state.rotationDegree);
                                    setMirrored(false);
                                    setBrightness(100);
                                    setContrast(100);
                                    AdjustScroll('initial');
                                }}
                            >
                                <div className='tools-button-div'>
                                    <FontAwesomeIcon icon={faExpand} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-rotateleft`}>
                                    <strong>Rotate Image Left by 90°</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-rotateleft'
                                className='tools'
                                onClick={() => performRotate('ACW')}
                            >
                                <div className='tools-button-div'>
                                    <FontAwesomeIcon icon={faUndo} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-rotateright`}>
                                    <strong>Rotate Image Right by 90°</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-rotateright'
                                className='tools'
                                onClick={() => {
                                    performRotate('CW');
                                }}
                            >
                                <div className='tools-button-div'>
                                    <FontAwesomeIcon icon={faRedo} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-mirror-image`}>
                                    <strong>Mirror Image</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-mirrored'
                                className='tools'
                                onClick={() =>
                                    setMirrored((prevState) => {
                                        return !prevState;
                                    })
                                }
                            >
                                <div className='tools-button-div'>
                                    <Icon.SymmetryVertical />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-invertcolor`}>
                                    <strong>Invert Image Colors</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-invertcolor'
                                className='tools'
                                onClick={() => toggleGrayscale(state.invert)}
                            >
                                <div className='tools-button-div'>
                                    <Icon.CircleHalf />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-noofpage`}>
                                    <strong>Number of Pages</strong>
                                </Tooltip>
                            }
                        >
                            <div className='tools-goto-div'>
                                <FormLabel
                                    id='tooltip-noofpage'
                                    className='no-of-pages disableSelection'
                                >
                                    {imageDataCtx.loadedImagePageNumber} of{' '}
                                    {imageDataCtx.loadedImageDetails
                                        ? imageDataCtx.loadedImageDetails.pageCount
                                        : 1}
                                </FormLabel>
                            </div>
                        </OverlayTrigger>
                    </div>
                    <div className='tools-goto-div'>
                        <span>Go to page:</span>
                        <form onSubmit={onGoToPageSubmit}>
                            <Form.Control
                                type='input'
                                size='sm'
                                name='goToPage'
                                value={goToPage}
                                onChange={(e) => onChangeGoToPage(e)}
                                onKeyDown={onKeyPressGoToPage}
                                style={{
                                    width: '42px',
                                    height: '1rem',
                                    marginLeft: '2px',
                                    marginRight: '2px',
                                }}
                            />
                        </form>
                        <a
                            id='tooltip-firstpage'
                            className='tools'
                            style={{
                                marginTop: '0',
                                cursor: 'pointer',
                                textDecoration: 'none',
                            }}
                            onClick={onGoToPageSubmit}
                        >
                            GO
                        </a>
                    </div>
                    <div
                        className='toolsSection'
                        onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                    >
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-firstpage`}>
                                    <strong>First Page</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-firstpage'
                                className={moveFirstPageEnabled ? 'tools' : 'disableViewerButton'}
                                onClick={(e) => onMoveFirstPage()}
                            >
                                <div className='tools-button-div'>
                                    <Icon.ArrowLeftCircle />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-lastpage`}>
                                    <strong>Last Page</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-lastpage'
                                className={moveLastPageEnabled ? 'tools' : 'disableViewerButton'}
                                onClick={(e) => onMoveLastPage()}
                            >
                                <div className='tools-button-div'>
                                    <Icon.ArrowRightCircle />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-previousimage`}>
                                    <strong>Previous Image</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-previousimage'
                                className={
                                    previousDocumentEnabled ? 'tools' : 'disableViewerButton'
                                }
                                onClick={(e) => onPreviousDocument()}
                            >
                                <div className='tools-button-div'>
                                    <FontAwesomeIcon icon={faStepBackward} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-nextimage`}>
                                    <strong>Next Image</strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id='tooltip-nextimage'
                                className={nextDocumentEnabled ? 'tools' : 'disableViewerButton'}
                                onClick={(e) => onNextDocument()}
                            >
                                <div className='tools-button-div'>
                                    <FontAwesomeIcon icon={faStepForward} size='1x' />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-help`}>
                                    <strong>Help</strong>
                                </Tooltip>
                            }
                        >
                            <a id='tooltip-help' className='tools' onClick={helpHandleShow}>
                                <div className='tools-button-div'>
                                    <Icon.QuestionSquareFill />
                                </div>
                            </a>
                        </OverlayTrigger>

                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='top'
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip className='disableSelection' id={`tooltip-details`}>
                                    <strong>Image Info</strong>
                                </Tooltip>
                            }
                        >
                            <a id='tooltip-details' className='tools' onClick={handleShow}>
                                <div className='tools-button-div'>
                                    <Icon.InfoCircle></Icon.InfoCircle>
                                </div>
                            </a>
                        </OverlayTrigger>
                    </div>
                </section>
            )}

            {/* New Viewer Implementation  start*/}
            <div className='viewer-body'>
                {(isPrintOpen || isSaveOpen) && (
                    <div className='exportOptions'>
                        <div className='exportOptionsContainer'>
                            <div className='exportOptionsTitle'>Select Pages</div>
                            <div className='exportOptionsInputs'>
                                <div>
                                    <input
                                        id='exportOptions'
                                        placeholder='e.g. 1-5, 8, 11-13'
                                        value={pagesToExport}
                                        onChange={onChangePagesToExport}
                                    />
                                </div>
                                <div>
                                    <input
                                        type='button'
                                        className='btn btn-primary btn-sm'
                                        value={isPrintOpen ? 'Print' : 'Save'}
                                        onClick={onExport}
                                    />
                                </div>
                            </div>
                            <div className='exportOptionsFooter'>
                                Max request {maximumTaggedPages} pages
                            </div>
                            {exportError && <div className='exportOptionsError'>{exportError}</div>}
                        </div>
                    </div>
                )}
                {isEditOpen && (
                    <div className='editTools'>
                        <div className='editToolContainer'>
                            <div className='editToolTitle'>Brightness</div>
                            <div>
                                <input
                                    type='number'
                                    id='brightnessValue'
                                    min='0'
                                    max='200'
                                    value={brightness}
                                    onChange={onChangeBrightness}
                                />
                            </div>
                        </div>
                        <div className='sliderContainer'>
                            <input
                                type='range'
                                min='0'
                                max='200'
                                value={brightness}
                                onChange={onChangeBrightness}
                                className='slider'
                                id='brightnessSlider'
                            />
                        </div>
                        <div className='editToolContainer'>
                            <div className='editToolTitle'>Contrast</div>
                            <div>
                                <input
                                    type='number'
                                    id='contrastValue'
                                    min='0'
                                    max='200'
                                    value={contrast}
                                    onChange={onChangeContrast}
                                />
                            </div>
                        </div>
                        <div className='sliderContainer'>
                            <input
                                type='range'
                                min='0'
                                max='200'
                                value={contrast}
                                onChange={onChangeContrast}
                                className='slider'
                                id='contrastSlider'
                            />
                        </div>
                    </div>
                )}
                {isThumbnailView && (
                    <div className='thumbnail-container'>
                        {totalThumbnailPages > 1 && (
                            <div className='thumbnail-pager'>
                                <a
                                    className={
                                        thumbnailPage === 1 ? 'disableViewerButton tools' : 'tools'
                                    }
                                    onClick={onThumbnailFirstPage}
                                    title='First'
                                >
                                    <Icon.SkipStart size={18} />
                                </a>
                                <a
                                    className={
                                        thumbnailPage === 1 ? 'disableViewerButton tools' : 'tools'
                                    }
                                    onClick={onThumbnailPreviousPage}
                                    title='Previous'
                                >
                                    <Icon.ChevronLeft size={18} />
                                </a>
                                <span className='thumbnail-pager-info'>
                                    Page {thumbnailPage} of {totalThumbnailPages}
                                    &nbsp;(images {thumbnailStartPage}–{thumbnailEndPage})
                                </span>
                                <a
                                    className={
                                        thumbnailPage === totalThumbnailPages
                                            ? 'disableViewerButton tools'
                                            : 'tools'
                                    }
                                    onClick={onThumbnailNextPage}
                                    title='Next'
                                >
                                    <Icon.ChevronRight size={18} />
                                </a>
                                <a
                                    className={
                                        thumbnailPage === totalThumbnailPages
                                            ? 'disableViewerButton tools'
                                            : 'tools'
                                    }
                                    onClick={onThumbnailLastPage}
                                    title='Last'
                                >
                                    <Icon.SkipEnd size={18} />
                                </a>
                                <form
                                    onSubmit={onThumbnailGoToPageSubmit}
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                    }}
                                >
                                    <span>Go to image:</span>
                                    <Form.Control
                                        type='input'
                                        size='sm'
                                        value={thumbnailGoToPage}
                                        onChange={onThumbnailGoToPageChange}
                                        style={{ width: '52px', height: '1rem' }}
                                    />
                                    <a
                                        className='tools'
                                        style={{ cursor: 'pointer', textDecoration: 'none' }}
                                        onClick={onThumbnailGoToPageSubmit}
                                    >
                                        GO
                                    </a>
                                </form>
                            </div>
                        )}
                        <div className='thumbnail-table-wrapper'>
                            <table>
                                <tbody>
                                    <tr>{thumbnailViewHtml}</tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
                {!isThumbnailView && (
                    <div
                        className='zoom-container disableSelection viewer-height'
                        ref={containerRef}
                    >
                        <div
                            id='section-to-print'
                            ref={wrapperRef}
                            onWheel={mouseWheel}
                            onMouseDown={mouseDown}
                            onMouseLeave={mouseLeave}
                            style={{
                                transform: `translate(${state.x}px, ${state.y}px) scale(${state.z})`,
                                transformOrigin: state.transformOrigin,
                                width: `auto`,
                                height: `auto`,
                                maxWidth: `auto`,
                                minWidth: `550px`,
                            }}
                        >
                            <img
                                ref={imgRef}
                                src={imageDataCtx.loadedImagePageUrl}
                                style={{
                                    transform: `rotate(${state.rotationDegree}deg) scaleX(${
                                        mirrored ? '-1' : '1'
                                    })`,
                                    filter: `grayscale(${state.invert}) invert(${state.invert}%) brightness(${brightness}%) contrast(${contrast}%)`,
                                    // transition: `ease 0.2s`,
                                    maxWidth: Props.isSearchBarOpen
                                        ? `100%`
                                        : state.rotationDegree == 0 || state.rotationDegree == 360
                                          ? `95vw`
                                          : `80vw`,
                                    height: `auto`,
                                }}
                                className='img-fluid'
                                onLoad={() => {
                                    imageLoad();
                                    AdjustScroll('initial');
                                }}
                            ></img>
                        </div>
                    </div>
                )}
            </div>
            {/* New Viewer Implementation end */}

            {imageDataCtx.loadedImageDetails && (
                <ImageModal
                    show={show}
                    data={imageDataCtx.loadedImageDetails}
                    handleShow={handleShow}
                    handleClose={handleClose}
                ></ImageModal>
            )}
            {Props && (
                <HelpModal
                    helpShow={helpShow}
                    helpHandleShow={helpHandleShow}
                    helpHandleClose={helpHandleClose}
                ></HelpModal>
            )}
            <IFramePrinter url={urlToPrint}></IFramePrinter>
            {!isThumbnailView && (
                <>
                    <a
                        className={previousPageEnabled ? 'prev' : 'disablePageButton prev'}
                        onClick={onPreviousPage}
                    >
                        &#10094;
                    </a>
                    <a
                        className={nextPageEnabled ? 'next' : 'disablePageButton next'}
                        onClick={onNextPage}
                    >
                        &#10095;
                    </a>
                </>
            )}
        </>
    );
};
export default Viewer;
